/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface PutFleetsFleetIdWingsWingIdNotFound
 */
export interface PutFleetsFleetIdWingsWingIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof PutFleetsFleetIdWingsWingIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the PutFleetsFleetIdWingsWingIdNotFound interface.
 */
export function instanceOfPutFleetsFleetIdWingsWingIdNotFound(value: object): value is PutFleetsFleetIdWingsWingIdNotFound {
    return true;
}

export function PutFleetsFleetIdWingsWingIdNotFoundFromJSON(json: any): PutFleetsFleetIdWingsWingIdNotFound {
    return PutFleetsFleetIdWingsWingIdNotFoundFromJSONTyped(json, false);
}

export function PutFleetsFleetIdWingsWingIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutFleetsFleetIdWingsWingIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PutFleetsFleetIdWingsWingIdNotFoundToJSON(json: any): PutFleetsFleetIdWingsWingIdNotFound {
    return PutFleetsFleetIdWingsWingIdNotFoundToJSONTyped(json, false);
}

export function PutFleetsFleetIdWingsWingIdNotFoundToJSONTyped(value?: PutFleetsFleetIdWingsWingIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

